import React from "react";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import AppButton from "../../global/components/AppButton/AppButton";

interface ErrorModalProps {
  open: boolean;
  onClose: () => void;
  message: string;
  locale?: string;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ open, onClose, message, locale = "en" }) => {
  if (!open || !message) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
        },
      }}
    >
      <DialogContent
        sx={{
          justifyContent: "center",
          p: 2,
        }}
      >
        <Typography
          variant="h5"
          color="secondary"
          sx={{
            textAlign: "center",
            fontWeight: 700,
            mb: 1,
          }}
        >
          {locale === "en" ? "Error" : "Erreur"}
        </Typography>

        <Box bgcolor="#ffe8e4" borderRadius="8px" mb={2}>
          <Typography
            sx={{
              color: "red",
              p: 1,
            }}
          >
            {message}
          </Typography>
        </Box>
        <Box display="flex" justifyContent="center">
          <AppButton
            label={locale === "en" ? "Close" : "Fermer"}
            withRadius
            onClick={onClose}
            styles={{
              fontSize: 14,
              paddingBottom: `8px`,
              paddingTop: `8px`,
              fontWeight: 400,
              width: "auto",
            }}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorModal;
